module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-posting-186b1d851f66cdc5c96c6a9fff65e8fe.svg";